
define('text!templates/modules/goal/edit/types/main-goal.html',[],function () { return '<div class="type-input"></div>\n{{^isDistance}}<div class="start-value-input"></div>{{/isDistance}}\n<div class="end-value-input"></div>\n<div class="end-date-input"></div>\n';});

